module.exports = __webpack_public_path__ + "img/norismiza.58dcf09c.jpg";